export function isPauseActive(until, now = new Date()) {
    const today = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
    return !!until && until >= today;
}

export function isMedicationPaused(medication, now = new Date()) {
    return !!medication.paused || isPauseActive(medication.pausedUntil, now)
        || isPauseActive(medication.globalPausedUntil, now);
}

// Existing date-based API/alarms treat this reserved value as paused until manual resume.
export const INDEFINITE_PAUSE_UNTIL = '9999-12-31';
